import type { VideoVoting } from 'open-modules/zdf/component/videovoting/videovoting-types';
import type { Datastore } from 'util/datastore';
import { useSessionData } from 'util/datastore';

export const VIDEO_VOTING_SESSION_STATES = {
    initVideo: 'initVideo', //The initial state. It should wait until the video is ready to play
    initSession: 'initSession', // Video voting gets initialized: Show the intro screen
    waitForQuestion: 'waitForQuestion', // Video plays, wait until a question triggers
    showQuestion: 'showQuestion', // Show question dialog
    showQuestionResults: 'showQuestionResults', // Show question dialog
    endScreen: 'endScreen', // Show the end screen
    ended: 'ended', // The video voting has finished
    disabled: 'disabled', // The videovoting has been disabled
    skippedVoting: 'skippedVoting', // The videovoting has been skipped for the current viewing session
};

export type VideoVotingSessionData = {
    state: string; // Current state of session
    id?: string | null; // Current id of session
    currentQuestionKey?: string; // The key of the current question
    anonymous?: boolean; // Wether anonymous voting is enabled
    questions: Record<string, VideoVotingSessionQuestionData>; // data about answered questions during session
    personaKey?: string | null; // key of the current user of the session
    voting?: VideoVoting; // the video voting object
    votingKey?: string; // key of the video voting,
    teaserDismissed?: boolean;
};

export type VideoVotingSessionQuestionData = {
    answered: boolean; // Wether the question was already answered in the current session
};

/** @public */
export type VideoVotingQuestionData = {
    answered: boolean; // Wether the question was already answered in the current session
};

export function useVideoVotingSessionData(): VideoVotingSessionData {
    const sessionData = useSessionData(['videoVotingSessionState']);
    return sessionData;
}

export function getVideoVotingSessionData(datastore: Datastore): VideoVotingSessionData {
    const sessionData = datastore.getSessionData(['videoVotingSessionState']);
    return sessionData;
}

export function setVideoVotingSessionData(datastore: Datastore, session: VideoVotingSessionData) {
    datastore.setSessionData(['videoVotingSessionState'], session);
}

export function updateVideoVotingSessionData(datastore: Datastore, session: Partial<VideoVotingSessionData>) {
    const sessionData = datastore.getSessionData(['videoVotingSessionState']);
    datastore.setSessionData(['videoVotingSessionState'], { ...sessionData, ...session });
}
